<lib-message
	[type]="'tip'"
	[dismissId]="'customExercisesTip'"
	[title]="'Unlimited exercises'"
	[className]="'push-bottom'"
>
	<div>You can create as many exercises as you need.</div>
</lib-message>

@if (table(); as table) {
<lib-card>
	<lib-table [table]="table"></lib-table>
</lib-card>
}
